<template>
<div>
    <v-dialog fullscreen persistent v-model="dialog_info" width="80%" style="z-index:9999000000; position:fixed; " >
                    <v-card>
                        <v-card-actions style="margin-top:5px;">
                            <v-spacer></v-spacer>
                            <a small color="default"  @click="dialog_info = false; crear()" title="Cerrar" v-tippy>
                                <v-icon large class="black--text" >close</v-icon>
                            </a>
                        </v-card-actions>
                        <v-card-text align-center style="margin-top:-70px">
                        <center>
                            <img src="https://s3.amazonaws.com/descargas.econnectpro.mx/sa31Fondo.png" alt="info" style="width:95%;" />


                        </center>
                        </v-card-text>
                        

                    </v-card>
                </v-dialog>

    <div id="pageIndexSA31" class="pa-5">
        <v-container grid-list-xl fluid>
            <div>

                <v-dialog v-model="dialog" max-width="600px" style="heigth:'auto'">
                    <v-card>

                        <v-card-text>
                            <h5>Porcentaje de Retorno - Opciones de consulta</h5>
                            <p />
                            <v-container grid-list-md text-xs-center>
                                <v-form ref="form1" v-model="valid" lazy-validation>

                                    <v-row no-gutters dense>
                                        <v-col>
                                            <v-menu offset-x ref="menuA1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="fecha_de" label="Fecha de Cargo" color="secondary" prepend-icon="event" @blur="fecha_de = parseDate(fecha_de)" v-mask="'####-##-##'" :rules="[ validaFechas(fecha_de, fecha_a)]"></v-text-field>
                                                </template>

                                                <v-date-picker v-model="fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false; atualizar_fecha() ">

                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menu1 = false; ">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col>
                                            <v-menu offset-x ref="menuA2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                                <template v-slot:activator="{ on }">
                                                    <v-text-field v-on="on" v-model="fecha_a" label="Fecha de Aplicación de Abono" color="secondary" prepend-icon="event" @blur="fecha_a= parseDate(fecha_a)" v-mask="'####-##-##'" :rules="[ validaFechas(fecha_de, fecha_a)]"></v-text-field>
                                                </template>
                                                <v-date-picker v-model="fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                                    <v-spacer />

                                                    <v-btn color="secondary" x-small @click="menu2 = false">
                                                        Cancelar
                                                    </v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters dense>
                                        <v-col>

                                            <v-autocomplete v-model="valoracion" :items="valoraciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Modelo de Valoración">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters dense v-if="valoracion=='ULTIMOS 12 MESES'">
                                        <v-col>

                                            <v-autocomplete v-model="presentacion" :items="presentaciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Periodo de Presentación">
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="planta_referencia" no-gutters dense>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-autocomplete v-model="planta" label="Planta Referencia" :items="plantas" :hide-no-data="true" item-text="referencia" item-value="referencia" clearable>

                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters dense>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-autocomplete v-model="destinos_cargos" :items="destinos_aduaneros_cargos" filled dense chips small-chips label="DESTINOS ADUANEROS EN CARGOS" item-text="clave" item-value="clave" multiple>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                    <v-row no-gutters dense>
                                        <v-col cols="12" sm="12" md="12">
                                            <v-autocomplete v-model="destinos_abonos" :items="destinos_aduaneros_abonos" filled dense chips small-chips label="DESTINOS ADUANEROS EN ABONOS" item-text="clave" item-value="clave" multiple>
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>

                            <v-spacer></v-spacer>
                            <v-btn small @click="dialog = false">Cancelar</v-btn>
                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; consultaPorcentajes();">Consultar</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <div>
                    <v-tabs grow style="margin-top:-20px; margin-left:-30px;" class="elevation-2 pa-1 ">

                        <v-tab :key="'in-a1'">
                            <v-icon large>mdi-calendar-clock</v-icon>&nbsp;&nbsp; Porcentajes de Retorno
                        </v-tab>
                        <v-tab :key="'in-a2'" @click="loader = 'loading'; loading=true; consultaDesgloses();">
                            <v-icon large>mdi-earth</v-icon> &nbsp;&nbsp; Desglose por Destino Aduanero
                        </v-tab>
                        <v-tab :key="'in-a3'" v-if="false">
                            <v-icon large>mdi-file-table-box-outline</v-icon> &nbsp;&nbsp; Valor de Retorno vs Valor Comercial
                        </v-tab>
                        <v-tab-item :key="'in-a1'" class="pa-10" style="text-align:center !important;">

                            <div id="grafica1" style="margin-top:-50px;">

                                <base-material-chart-card :options="data_grafica1" color="white" type="Bar">
                                    <h5 class="card-title font-weight-light mt-2 ml-2"></h5>
                                </base-material-chart-card>

                            </div>

                            <v-row>
                                <v-col lg="6" style="padding-top:10px;">

                                    <div class="d-inline-flex text-left" style=" z-index:1;    width:100%">
                                        <span class="overline secondary--text font-weight-light "><span v-if="planta_referencia" class="overline primary--text font-weight "> {{planta}} </span> Fecha de Cargo: {{fecha_de}} - Fecha de Aplicación de Abono: {{fecha_a}}
                                            <v-btn small light icon title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
                                                <v-icon small color="secondary">mdi-calendar-search</v-icon>
                                            </v-btn>

                                        </span>

                                    </div>
                                    <v-client-table style="margin-top:0px;width:100%" ref="vuetableA" :data="data_tableA" :columns="columns_tableA" :options="tableA_options" class="elevation-2 pa-2 footer-hide">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="cargos" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.cargos)}}</div>
                                        </template>
                                        <template slot="abonos" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.abonos)}}</div>
                                        </template>
                                        <template slot="porcentaje" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.porcentaje,2)}} %</div>
                                        </template>
                                        <template slot="ejercicio" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-center'"> {{ props.row.ejercicio}}</div>
                                        </template>
                                    </v-client-table>
                                    <br />
                                    <div style="text-align:right">
                                        <v-btn color="red" @click="openNew('/sa31/reportes/proximo_periodo');">
                                            <v-icon small color="white">search</v-icon> CONSULTAR PERIODOS OMITIDOS
                                        </v-btn>
                                    </div>

                                </v-col>

                                <v-col lg="6" style="padding-top:38px;">

                                    <div class="elevation-2 pa-2">
                                        <h5><b>MONITOR DE PRESENTACIÓN DE INFORMES</b></h5>
                                        <table class="VueTables__table table  table-bordered  ">

                                            <tr style="padding=0.75rem" class="font-weight-bold">
                                                <td>
                                                </td>
                                                <td>PERIODO
                                                </td>
                                                <td>FECHA SUGERIDA PARA PRESENTAR
                                                </td>
                                                <td>FECHA LIMITE PARA PRESENTAR
                                                </td>
                                                <td>SIMULADOS
                                                </td>
                                            </tr>

                                            <tbody>
                                                <tr :style="'background-color:'+ ultimo_presentado[0].color">
                                                    <td>ULTIMO PERIODO PRESENTADO
                                                    </td>
                                                    <td>{{ ultimo_presentado[0].nombre }} {{ ultimo_presentado[0].ejercicio }}
                                                    </td>
                                                    <td>{{ ultimo_presentado[0].fecha_sugerida }}
                                                    </td>
                                                    <td> {{ ultimo_presentado[0].fecha_limite }}
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                                <tr :style="'background-color:'+ ultimo_presentado[1].color">
                                                    <td>PERIODO POR PRESENTAR
                                                    </td>
                                                    <td>{{ ultimo_presentado[1].nombre}} {{ ultimo_presentado[1].ejercicio }}
                                                    </td>
                                                    <td>{{ ultimo_presentado[1].fecha_sugerida }}
                                                    </td>
                                                    <td> {{ ultimo_presentado[1].fecha_limite }}
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                                <tr v-if="ultimo_presentado.length > 2" :style="'background-color:'+ ultimo_presentado[2].color">
                                                    <td>
                                                    </td>
                                                    <td>{{ ultimo_presentado[2].nombre}} {{ ultimo_presentado[2].ejercicio }}
                                                    </td>
                                                    <td>{{ ultimo_presentado[2].fecha_sugerida }}
                                                    </td>
                                                    <td> {{ ultimo_presentado[2].fecha_limite }}
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                                <tr v-if="ultimo_presentado.length > 3" :style="'background-color:'+ ultimo_presentado[3].color">
                                                    <td>
                                                    </td>
                                                    <td>{{ ultimo_presentado[3].nombre}} {{ ultimo_presentado[3].ejercicio }}
                                                    </td>
                                                    <td>{{ ultimo_presentado[3].fecha_sugerida }}
                                                    </td>
                                                    <td> {{ ultimo_presentado[3].fecha_limite }}
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                        <v-tab-item :key="'in-a2'" class="pa-5" style="text-align:left !important;">
                            <v-row style="margin-top:-30px;">
                                <v-col lg="6">
                                    <v-row no-gutters dense>
                                        <v-col lg="5" class="pa-5">

                                            <v-autocomplete v-model="valoracion2" :items="valoraciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Modelo de Valoración">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col v-if="'EJERCICIO FISCAL' == valoracion2" lg="4" class="pa-5">

                                            <v-autocomplete v-model="ejercicio" :items="ejercicios" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Ejercicio">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col lg="2" class="pa-5">
                                            <p />
                                            <v-btn small :loading="loading" :disabled="loading || !valid" color="primary" @click="loader = 'loading'; loading=true; consultaDesgloses();">Consultar</v-btn>
                                        </v-col>
                                    </v-row>

                                </v-col>
                                <v-col lg="6" style="text-align:center;" v-if="data_tableB_cargos.length>0 || data_tableB_abonos.length>0">

                                    <div style="margin-top:50px;">
                                        <v-spacer></v-spacer>
                                        <h3> <strong>SALDO: </strong><span style="color:rgb(129, 10, 10)"> {{ formatNumber(total_saldo) }}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <strong class="circle">%{{porcentaje_saldo}}</strong></h3>
                                    </div>

                                </v-col>
                            </v-row>
                            <v-row v-if="data_tableB_cargos.length>0 || data_tableB_abonos.length>0">

                                <v-col lg="12" class="pa-10 pt-0">
                                    <div class="d-inline-flex text-left" style=" z-index:1;    width:100%">
                                        <span class="overline secondary--text font-weight-light ">
                                            <span v-if="planta_referencia" class="overline primary--text font-weight "> </span> PERÍODO CONSULTADO: DE {{fecha_de2}} A {{fecha_a2}}</span>

                                    </div>
                                    <div id="grafica1">
                                        <base-material-chart-card :options="data_grafica2" color="white" type="Bar">
                                            <h5 class="card-title font-weight-light mt-2 ml-2"></h5>
                                        </base-material-chart-card>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row v-if="data_tableB_cargos.length>0 || data_tableB_abonos.length>0">
                                <v-col lg="6" class="pa-0">
                                    <span class=" mt-2 ml-2 font-weight-bold primary--text">CARGOS</span>
                                    <v-client-table style="margin-top:0px;width:95%" ref="vuetableB" :data="data_tableB_cargos" :columns="columns_tableB_cargos" :options="tableB_cargos_options" class="elevation-2 pa-2 footer-hide">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="valor" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.valor)}}</div>
                                        </template>
                                        <template slot="iva" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.iva)}}</div>
                                        </template>
                                        <template slot="ieps" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.ieps)}}</div>
                                        </template>
                                        <template slot="destino" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ props.row.destino}}</div>
                                        </template>
                                    </v-client-table>
                                </v-col>
                                <v-col lg="6" class="pa-0">
                                    <span class=" mt-2 ml-2 font-weight-bold secondary--text">ABONOS</span>
                                    <v-client-table style="margin-top:0px;width:95%" ref="vuetableC" :data="data_tableB_abonos" :columns="columns_tableB" :options="tableB_abonos_options" class="elevation-2 pa-2 footer-hide">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="valor" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.valor)}}</div>
                                        </template>
                                        <template slot="destino" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ props.row.destino}}</div>
                                        </template>
                                    </v-client-table>
                                </v-col>
                            </v-row>
                        </v-tab-item>

                        <v-tab-item class="pa-10" :key="'in-a3'" style="text-align:center !important;">

                            <div class="d-inline-flex text-left" style=" z-index:1;    width:100%">
                                <v-spacer />
                                <span class="overline secondary--text font-weight-light "> <span v-if="planta_referencia" class="overline primary--text font-weight "> {{planta}} </span> Fecha de Cargo: {{fecha_de}} - Fecha de Aplicación de Abono: {{fecha_a}}
                                    <v-btn small light icon title="Seleccionar Periodo" @click="dialog = !dialog" v-tippy>
                                        <v-icon small color="secondary">mdi-calendar-search</v-icon>
                                    </v-btn>

                                </span>

                            </div>
                            <h6 class=" mt-2 ml-2">ABONOS</h6>
                            <v-client-table style="margin-top:0px;width:100%" ref="vuetableD" :data="data_tableD" :columns="columns_tableD" :options="tableD_options" class="elevation-2 pa-2 footer-hide">
                                <template slot="noResults">
                                    <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                </template>

                            </v-client-table>
                        </v-tab-item>
                    </v-tabs>
                    <LoaderFraces ref="fracesLoader" :mensajes="lista_mensajes"></LoaderFraces>

                </div>
            </div>
        </v-container>

    </div>
</div>
</template>

    
    
<script>
import axios from "axios";
import moment from "moment";
import LoaderFraces from "@/components/LoaderFraces";

var colors_bars = [
    "#08c1ff",
    "#f8cddb",
    "#fffac8",
    "#f4b58f",
    "#eed68f",
    "#aa9499",
    "#aaf0d1",
    "#b2fba5",
    "#ff6961",
    "#ff9899",
    "#ca9bf7"
];

export default {
    components: {
        LoaderFraces
    },

    data: () => ({
        periodos: "",
        dialog_info: false,
        fecha_de2: "",
        fecha_a2: "",
        total_saldo: "0.00",
        porcentaje_saldo: "0%",
        primero: "",
        lista_mensajes: [
            "ESTAMOS PROCESANDO EL PANEL PRINCIPAL..",
            "AGRADECEMOS SU PACIENCIA..",
            "GESTIONANDO INDICADORES DE VALOR..",
            "VERIFICANDO PORCENTAJES DE RETORNO..",
            "ANALIZANDO VALORES POR PERIODO.."
        ],
        ejercicio: 2023,
        valoracion2: "EJERCICIO FISCAL",
        ejercicios: [],
        destinos_aduaneros_cargos: ['IN', 'V1', 'E1'],
        destinos_aduaneros_abonos: ['RT', 'V1', 'CTM', 'BM', 'BO', 'L1', 'H1', 'H8', 'A1'],
        destinos_cargos: ['IN', 'V1', 'E1'],
        destinos_abonos: ['RT', 'V1', 'CTM'],
        tipo_periodo: 'Mensual',
        fab: false,
        plantas: [],
        breadcrumbs: [{
            text: "Inicio",
            disabled: true,
            to: ""
        }, ],
        valoraciones: [{
            "id": "EJERCICIO FISCAL"
        }, {
            "id": "ULTIMOS 12 MESES"
        }],
        valoracion: "EJERCICIO FISCAL",
        presentaciones: [{
            "id": "MENSUAL"
        }, {
            "id": "BIMESTRAL"
        }],
        presentacion: "MENSUAL",
        valid: true,
        dialog: false,
        loader: null,
        loading: false,
        data_tableA: [],
        data_tableB_cargos: [

        ],
        data_tableB_abonos: [

        ],
        data_tableD: [

        ],
        planta: '',
        columns_tableA: [
            "ejercicio",
            "cargos",
            "abonos",
            "porcentaje",

        ],
        tableA_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "ejercicio": "EJERCICIO",
                "cargos": "CARGOS",
                "abonos": "ABONOS",
                "porcentaje": "PORCENTAJE",

            }
        },
        columns_tableB: [
            "destino",
            "valor",

        ],
        columns_tableB_cargos: [
            "destino",
            "valor",
            "iva",
            "ieps"
        ],
        tableB_cargos_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "destino": "DESTINO ADUANERO",
                "valor": "SUMA DE VALOR EN MN",
                "iva": "CRÉDITO FISCAL IVA",
                "ieps": "CRÉDITO FISCAL IEPS",

            }
        },
        tableB_abonos_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "destino": "DESTINO ADUANERO",
                "valor": "VALOR COMERCIAL DESCARGO",

            }
        },
        columns_tableD: [
            "folio",
            'periodo',
            "destino",
            "valor_abono",
            "indicador",
            "destino",
            "valor_cargo",
            "valor_cargo",
            "valor_cargo_agregado"
        ],
        tableD_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "folio": "FOLIO SAT",
                'periodo': "PERIODO AFECTADO",
                "destino": "DESTINO ADUANERO",
                "valor_abono": "VALOR COMERCIAL DESCARGO",
                "indicador": "% ",
                "destino": "DESTINO ADUANERO",
                "valor_cargo": "SUMA DE VALOR EN MN",
                "valor_cargo_agregado": "SUMA DE VALOR AGREGADO"

            }
        },

        menu1: false,
        menu2: false,
        fecha_de: "",
        fecha_a: "",
        data_grafica1: {
            chart: {
                type: "column",
                backgroundColor: null,
                height: 250,
                spacingBottom: 2,
                spacingTop: 2,
                spacingLeft: 2,
                spacingRight: 2,
                marginRight: 2,
                marginLeft: 40,
                marginTop: 2,
                marginBottom: 30,

            },
            credits: {
                enabled: false
            },
            csecondaryits: false,
            title: {
                text: ""
            },

            navigator: {
                yAxis: {
                    gridLineColor: '#000'
                }
            },
            colors: colors_bars,
            xAxis: {
                categories: [],
                gridLineWidth: 1,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },

            },

            yAxis: {
                allowDecimals: false,
                gridLineWidth: 1,
                minorGridLineWidth: 1,
                minorTicks: true,
                min: 0,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },
            },

            tooltip: {
                formatter: function () {
                    return false;
                    return (
                        "% " + this.y
                    );
                }
            },

            plotOptions: {
                candlestick: {
                    lineColor: 'secondary'
                },
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.1f}%'
                    }
                }
            },
            legend: {
                enabled: false
            },
            series: []
        },
        data_grafica2: {

            chart: {
                type: "column",
                backgroundColor: null,
                height: 250,
                spacingBottom: 2,
                spacingTop: 2,
                spacingLeft: 2,
                spacingRight: 2,
                marginRight: 2,
                marginLeft: 40,
                marginTop: 2,
                marginBottom: 30,

            },
            credits: {
                enabled: false
            },
            csecondaryits: false,
            title: {
                text: ""
            },
            navigator: {
                yAxis: {
                    gridLineColor: '#000'
                }
            },
            colors: colors_bars,
            xAxis: {
                categories: ['CARGOS', 'ABONOS'],
                gridLineWidth: 1,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },

            },

            yAxis: {
                allowDecimals: false,
                gridLineWidth: 1,
                minorGridLineWidth: 1,
                minorTicks: true,
                min: 0,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },
            },

            tooltip: {
                formatter: function () {
                    return (
                        this.series.name + ": " + this.y
                    );
                }
            },

            plotOptions: {
                column: {
                    stacking: 'normal',
                    dataLabels: {
                        enabled: true
                    }
                },
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.series.name}'
                    }
                }
            },
            legend: {
                enabled: false
            },
            series: []

        },
        ultimo_presentado: [{}, {}],
        meses: ['', 'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC']
    }),
    computed: {

        planta_referencia() {
            return this.$local_storage.get("Modulo16") == 100;
        },

    },
    methods: {
        openNew: function (h) {
            window.open(h, "_blank");
        },

    async crear() {

            let self = this;
            var f_a = new Date();

            let y = f_a.getFullYear();
            let m = f_a.getMonth() + 1;
            let d = f_a.getDate();

            for (let i = 2015; i <= y; i++) {

                self.ejercicios.push({
                    'id': i
                });
            }
            if (m < 10)
                m = '0' + m;
            if (d < 10)
                d = '0' + d;

            let fecha = y + "-" + m + "-01";
            this.ejercicio = y;
            this.fecha_de = fecha;
            await this.atualizar_fecha();

            await this.getPeriodos();
            await this.cargarConfig();
            if (this.planta_referencia)
                this.cargarPlantas();

            // this.consultaCargosAnio();
            this.$local_storage.set('verSA31', 0);
            },
        formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
        atualizar_fecha: function () {
            if (this.presentacion == 'MENSUAL') {

                let f_de = new Date(this.fecha_de);
                let y = f_de.getFullYear();
                let m = f_de.getMonth() + 1;
                if (m < 10)
                    m = '0' + m;
                let ultimoDia = new Date(f_de.getFullYear(), f_de.getMonth() + 1, 0);

                this.fecha_a = y + "-" + m + "-" + ultimoDia.getDate();
            } else {

                let f_de = new Date(this.fecha_de);
                let y = f_de.getFullYear();
                let m = f_de.getMonth() + 1;

                if ((m % 2) == 0) {
                    m = m + 1;
                }
                let ultimoDia = new Date(f_de.getFullYear(), m + 1, 0);
                if (m < 10)
                    m = '0' + m;

                this.fecha_a = y + "-" + m + "-" + ultimoDia.getDate();
            }
        },
        validaFechas: function (FD, FA) {
            if (FD == null)
                FD = ""
            if (FA == null)
                FA = ""

            if (FD != "" && FD == "") {
                return "Debe seleccionar las dos fechas o ninguna."
            } else if (FD == "" && FA != "") {
                return "Debe seleccionar las dos fechas o ninguna."
            }
            return true;
        },
        cargarPlantas: async function () {

            let data = {
                cliente: this.$local_storage.get("id_cliente"),
            };
            await axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.plantas = res.data;

                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getPeriodos: function () {

            axios.post(this.$hostname + "apendices/lista/", {
                    'tabla': 32
                })
                .then(response => {

                    this.periodos = response.data;

                })
                .catch(error => {

                });
        },
        cargarPrimero: async function () {
            let self = this;
            var f_a = new Date();

            let y = f_a.getFullYear();
            let m = f_a.getMonth() + 1;
            let d = f_a.getDate();

            if (m < 10)
                m = '0' + m;
            if (d < 10)
                d = '0' + d;

            let fecha_hoy = y + "-" + m + "-" + d;

            let data = {
                rfc: this.$local_storage.get("rfc"),
            };
            await axios.post(this.$apiSA31 + "soluciona31/descargos_ultimo_informe/", data)
                .then(res => {
                    if (typeof res.data !== "undefined" && res.data.length > 0 ) {
                        this.primero = res.data;
                        let mes_ultimo = 0;
                        let ejercicio_ultimo = 0;
                        if (self.periodos.length>0){

                        
                            let encontrado = self.periodos.filter(item => {
                                return item.clave == self.primero[0].cabecera.periodo_asociado
                            });
                            if (encontrado.length > 0) {
                                self.ultimo_presentado[0] = encontrado[0];
                                self.ultimo_presentado[0].ejercicio = self.primero[0].cabecera.ejercicio;
                                mes_ultimo = encontrado[0].mes_a;

                                if (parseInt(encontrado[0].mes_a) < 10)
                                    encontrado[0].mes_a = "0" + encontrado[0].mes_a;

                                self.fecha_de = self.primero[0].cabecera.ejercicio + "-" + encontrado[0].mes_a + "-" + encontrado[0].dia_a
                                self.fecha_a = self.fecha_de;
                                self.ultimo_presentado[0].fecha = self.fecha_de;
                                var date = new Date(self.fecha_de);

                                let dias = 20;

                                if (encontrado[0].dia_a == 28)
                                    dias = 21;

                                self.ultimo_presentado[0].fecha_sugerida = moment(date.setDate(date.getDate() + dias)).format('DD-MM-YYYY');
                                self.ultimo_presentado[0].fecha_limite = moment(date.setDate(date.getDate() + 6)).format('DD-MM-YYYY');
                                ejercicio_ultimo = self.primero[0].cabecera.ejercicio;
                                self.ultimo_presentado[0].color = '#b0f2c2';
                                self.ejercicios = [];
                                for (let i = 2015; i <= ejercicio_ultimo; i++) {

                                    self.ejercicios.push({
                                        'id': i
                                    });
                                }
                                this.ejercicio = ejercicio_ultimo;
                            }
                            let encontrado_sig = [];
                            if (mes_ultimo == 12) {
                                mes_ultimo = 1;
                                encontrado_sig = self.periodos.filter(item => {
                                    return item.mes_de == 1 && item.tipo == self.ultimo_presentado[0].tipo
                                });
                                ejercicio_ultimo += 1;
                            } else {
                                encontrado_sig = self.periodos.filter(item => {
                                    return item.clave == self.primero[0].cabecera.periodo_asociado + 1
                                });
                            }

                            if (encontrado_sig.length > 0) {
                                self.ultimo_presentado[1] = encontrado_sig[0];
                                self.ultimo_presentado[1].ejercicio = ejercicio_ultimo;
                                mes_ultimo = encontrado_sig[0].mes_a;
                                if (parseInt(encontrado_sig[0].mes_a) < 10)
                                    encontrado_sig[0].mes_a = "0" + encontrado_sig[0].mes_a;

                                self.ultimo_presentado[1].fecha = ejercicio_ultimo + "-" + encontrado_sig[0].mes_a + "-" + encontrado_sig[0].dia_a;

                                var date = new Date(self.ultimo_presentado[1].fecha);

                                let dias = 20;
                                if (encontrado_sig[0].dia_a == 28)
                                    dias = 21;

                                self.ultimo_presentado[1].fecha_sugerida = moment(date.setDate(date.getDate() + dias)).format('DD-MM-YYYY');
                                self.ultimo_presentado[1].fecha_limite = moment(date.setDate(date.getDate() + 6)).format('DD-MM-YYYY');
                                if (new Date(self.ultimo_presentado[1].fecha) <= new Date(fecha_hoy))
                                    self.ultimo_presentado[1].color = '#fcb7af';
                                else
                                    self.ultimo_presentado[1].color = '#fdf9c4';

                                let encontrado_sig2 = [];

                                if (mes_ultimo == 12) {
                                    mes_ultimo = 1;
                                    encontrado_sig2 = self.periodos.filter(item => {
                                        return item.mes_de == 1 && item.tipo == self.ultimo_presentado[0].tipo
                                    });
                                    ejercicio_ultimo += 1;
                                } else {
                                    encontrado_sig2 = self.periodos.filter(item => {
                                        return item.clave == parseInt(self.ultimo_presentado[1].clave) + 1
                                    });
                                }
                                if (encontrado_sig2.length > 0) {

                                    if (parseInt(encontrado_sig2[0].mes_a) < 10)
                                        encontrado_sig2[0].mes_a = "0" + encontrado_sig2[0].mes_a;

                                    let fecha_siguiente = ejercicio_ultimo + "-" + encontrado_sig2[0].mes_a + "-" + encontrado_sig2[0].dia_a;
                                    mes_ultimo = encontrado_sig2[0].mes_a;

                                    let dias = 20;
                                    if (encontrado_sig2[0].dia_a == 28)
                                        dias = 21;
                                    self.ultimo_presentado[2] = encontrado_sig2[0];
                                    self.ultimo_presentado[2].ejercicio = ejercicio_ultimo;
                                    self.ultimo_presentado[2].fecha = fecha_siguiente;

                                    var date = new Date(self.ultimo_presentado[2].fecha);

                                    self.ultimo_presentado[2].fecha_sugerida = moment(date.setDate(date.getDate() + dias)).format('DD-MM-YYYY');
                                    self.ultimo_presentado[2].fecha_limite = moment(date.setDate(date.getDate() + 6)).format('DD-MM-YYYY');

                                    if (new Date(fecha_siguiente) <= new Date(fecha_hoy)) {
                                        self.ultimo_presentado[2].color = '#fcb7af';
                                        let encontrado_sig3 = [];

                                        if (mes_ultimo == 12) {
                                            mes_ultimo = 1;
                                            encontrado_sig3 = self.periodos.filter(item => {
                                                return item.mes_de == 1 && item.tipo == self.ultimo_presentado[0].tipo
                                            });
                                            ejercicio_ultimo += 1;
                                        } else {
                                            encontrado_sig3 = self.periodos.filter(item => {
                                                return item.clave == parseInt(self.ultimo_presentado[2].clave) + 1
                                            });
                                        }
                                        if (encontrado_sig3.length > 0) {

                                            if (parseInt(encontrado_sig3[0].mes_a) < 10)
                                                encontrado_sig3[0].mes_a = "0" + encontrado_sig3[0].mes_a;

                                            let fecha_siguiente = ejercicio_ultimo + "-" + encontrado_sig3[0].mes_a + "-" + encontrado_sig3[0].dia_a;
                                            mes_ultimo = encontrado_sig3[0].mes_a;

                                            let dias = 20;
                                            if (encontrado_sig3[0].dia_a == 28)
                                                dias = 21;
                                            self.ultimo_presentado[3] = encontrado_sig3[0];
                                            self.ultimo_presentado[3].ejercicio = ejercicio_ultimo;
                                            self.ultimo_presentado[3].fecha = fecha_siguiente;

                                            var date = new Date(self.ultimo_presentado[3].fecha);

                                            self.ultimo_presentado[3].fecha_sugerida = moment(date.setDate(date.getDate() + dias)).format('DD-MM-YYYY');
                                            self.ultimo_presentado[3].fecha_limite = moment(date.setDate(date.getDate() + 6)).format('DD-MM-YYYY');

                                            if (new Date(fecha_siguiente) <= new Date(fecha_hoy)) {
                                                self.ultimo_presentado[3].color = '#fcb7af';
                                                let encontrado_sig4 = [];

                                                if (mes_ultimo == 12) {
                                                    mes_ultimo = 1;
                                                    encontrado_sig4 = self.periodos.filter(item => {
                                                        return item.mes_de == 1 && item.tipo == self.ultimo_presentado[0].tipo
                                                    });
                                                    ejercicio_ultimo += 1;
                                                } else {
                                                    encontrado_sig4 = self.periodos.filter(item => {
                                                        return item.clave == parseInt(self.ultimo_presentado[3].clave) + 1
                                                    });
                                                }
                                                if (encontrado_sig4.length > 0) {

                                                    if (parseInt(encontrado_sig4[0].mes_a) < 10)
                                                        encontrado_sig4[0].mes_a = "0" + encontrado_sig4[0].mes_a;

                                                    let fecha_siguiente = ejercicio_ultimo + "-" + encontrado_sig4[0].mes_a + "-" + encontrado_sig4[0].dia_a;

                                                    let dias = 20;
                                                    if (encontrado_sig4[0].dia_a == 28)
                                                        dias = 21;
                                                    self.ultimo_presentado[4] = encontrado_sig4[0];
                                                    self.ultimo_presentado[4].ejercicio = ejercicio_ultimo;
                                                    self.ultimo_presentado[4].fecha = fecha_siguiente;

                                                    var date = new Date(self.ultimo_presentado[4].fecha);

                                                    self.ultimo_presentado[4].fecha_sugerida = moment(date.setDate(date.getDate() + dias)).format('DD-MM-YYYY');
                                                    self.ultimo_presentado[4].fecha_limite = moment(date.setDate(date.getDate() + 6)).format('DD-MM-YYYY');

                                                    if (new Date(fecha_siguiente) <= new Date(fecha_hoy)) {
                                                        self.ultimo_presentado[4].color = '#fcb7af';
                                                    } else {
                                                        self.ultimo_presentado[4].color = '#fdf9c4';
                                                    }
                                                }
                                            } else {
                                                self.ultimo_presentado[3].color = '#fdf9c4';
                                            }
                                        }
                                    } else {
                                        self.ultimo_presentado[2].color = '#fdf9c4';
                                    }

                                }
                            }
                        }

                    }
                })
                .catch(err => {
                    console.log(err);
                }).then(res => {
                    this.consultaInicial();

                });
        },

        cargarConfig: function () {

            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),
            };

            axios.post(this.$hostname + "catalogos/clientes_certificaciones/get_destinos_cliente/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                      
                        this.destinos_cargos = res.data.destinos_cargos.split(",");
                        this.destinos_abonos = res.data.destinos_abonos.split(",");
                        this.presentacion = res.data.valoracion;
                    }
                })
                .catch(err => {
                    console.log();
                }).then(res => {
                    this.cargarPrimero();

                });
        },
        guardarConfig: function () {

            let dc = null;
            let da = null;
            if (this.destinos_cargos.length > 0)
                dc = this.destinos_cargos.toString();

            if (this.destinos_abonos.length > 0)
                da = this.destinos_abonos.toString();

            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),
                destinos_cargos: dc,
                destinos_abonos: da,
                valoracion: this.presentacion
            };

            axios.post(this.$hostname + "catalogos/clientes_certificaciones/guardar_destinos_cliente/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        console.log(res.data);
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        consultaInicial: function () {

            this.$refs.fracesLoader.show('BIENVENIDO A SOLUCIÓNA31 PROCONTROL ..');
            let self = this;
            let total_cargos = 0;
            let total_abonos = 0;
            this.data_tableA = [];
            let data_cargos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_cargo: this.fecha_de,
                destinos: this.destinos_cargos
            };
            let data_abonos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_abono: this.fecha_a,
                destinos: this.destinos_abonos
            };
            if (this.planta != '') {
                data_cargos = {
                    rfc: this.$local_storage.get("rfc"),
                    fecha_cargo: this.fecha_de,
                    destinos: this.destinos_cargos,
                    planta: this.planta
                }
                data_abonos = {
                    rfc: this.$local_storage.get("rfc"),
                    fecha_abono: this.fecha_a,
                    destinos: this.destinos_abonos,
                    planta: this.planta
                }

            }

            if (this.valoracion == 'EJERCICIO FISCAL') {
                axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_anio/", data_cargos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            let cargos = res.data;
                            cargos = res.data.sort(function (a, b) {
                                return parseInt(b.anio) - parseInt(a.anio);
                            });
                         
                            axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_anio/", data_abonos)
                                .then(res => {
                                    if (typeof res.data !== "undefined") {
                                        cargos.forEach(function (c) {
                                            self.data_tableA.push({
                                                "ejercicio": c.anio,
                                                "cargos": parseInt(c.valor),
                                                "abonos": "0",
                                                "porcentaje": "0",

                                            });
                                        });
                                        let abonos = res.data;
                                        abonos.forEach(function (a) {
                                            let encontrado = self.data_tableA.filter(item => {
                                                return item.ejercicio == a.anio
                                            });

                                            if (encontrado.length > 0) {
                                                encontrado[0].abonos = parseInt(a.valor);
                                                encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                            } else {
                                                self.data_tableA.push({
                                                    "ejercicio": a.anio,
                                                    "cargos": "0",
                                                    "abonos": parseInt(a.valor),
                                                    "porcentaje": "0",

                                                });
                                            }

                                        });

                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.loading = false;
                                }).then(res => {
                                    this.dialog = false;
                                    this.loading = false;
                                    this.$refs.fracesLoader.hide();

                                    self.llenarGrafica1();
                                });

                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    }).then(res => {
                        this.dialog = false;

                        self.llenarGrafica1();
                        this.$refs.fracesLoader.hide();
                    });

            } else {
                axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_mes/", data_cargos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            let cargos = res.data;

                            axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_mes/", data_abonos)
                                .then(res => {
                                    if (typeof res.data !== "undefined") {

                                        let abonos = res.data;
                                        cargos.forEach(function (c) {
                                            if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                                if (c.mes % 2 == 0) {
                                                    self.data_tableA.push({

                                                        "ejercicio": c.anio + '-' + self.meses[c.mes - 1] + '-' + self.meses[c.mes],
                                                        "cargos": parseInt(c.valor),
                                                        "abonos": "0",
                                                        "porcentaje": "0",

                                                    });
                                                    total_cargos += parseInt(c.valor);
                                                } else {
                                                    let encontrado2 = self.data_tableA.filter(item => {
                                                        return item.ejercicio == c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1]
                                                    });

                                                    if (encontrado2.length > 0) {
                                                        encontrado2[0].cargos = parseInt(encontrado2[0].cargos) + parseInt(c.valor);
                                                        encontrado2[0].porcentaje = parseInt((parseFloat(encontrado2[0].abonos) / parseFloat(encontrado2[0].cargos)) * 100);
                                                        total_cargos += parseInt(c.valor);
                                                    } else {
                                                        self.data_tableA.push({

                                                            "ejercicio": c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1],
                                                            "cargos": parseInt(c.valor),
                                                            "abonos": "0",
                                                            "porcentaje": "0",

                                                        });
                                                        total_cargos += parseInt(c.valor);
                                                    }

                                                }

                                            } else {
                                                total_cargos += parseInt(c.valor);
                                                self.data_tableA.push({

                                                    "ejercicio": c.anio + '-' + self.meses[c.mes],
                                                    "cargos": parseInt(c.valor),
                                                    "abonos": "0",
                                                    "porcentaje": "0",

                                                });
                                            }

                                        });
                                        abonos.forEach(function (a) {

                                            if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                                if (a.mes % 2 == 0) {
                                                    let encontrado = self.data_tableA.filter(item => {
                                                        return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes - 1]
                                                    });

                                                    if (encontrado.length > 0) {
                                                        encontrado[0].abonos = parseInt(encontrado[0].abonos) + parseInt(a.valor);
                                                        encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                        total_abonos += parseInt(a.valor);
                                                    }
                                                } else {
                                                    let encontrado = self.data_tableA.filter(item => {
                                                        return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes + 1]
                                                    });

                                                    if (encontrado.length > 0) {
                                                        encontrado[0].abonos = parseInt(a.valor);
                                                        encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                        total_abonos += parseInt(a.valor);
                                                    }
                                                }
                                            } else {
                                                let encontrado = self.data_tableA.filter(item => {
                                                    return item.ejercicio == a.anio + '-' + self.meses[a.mes]
                                                });

                                                if (encontrado.length > 0) {
                                                    total_abonos += parseInt(a.valor);
                                                    encontrado[0].abonos = parseInt(a.valor);
                                                    encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                }
                                            }

                                        });

                                        self.llenarGrafica1();
                                        if (self.valoracion == "ULTIMOS 12 MESES") {
                                            self.data_tableA.push({

                                                "ejercicio": 'TOTAL',
                                                "cargos": total_cargos,
                                                "abonos": total_abonos,
                                                "porcentaje": parseInt((total_abonos / total_cargos) * 100),

                                            });
                                        }

                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.loading = false;
                                }).then(res => {
                                    this.dialog = false;
                                    this.loading = false;
                                    this.$refs.fracesLoader.hide();

                                    self.llenarGrafica1();
                                    this.guardarConfig();
                                });

                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    });
            }

        },
        consultaPorcentajes: function () {

            this.$refs.fracesLoader.show('ESPERE UN MOMENTO POR FAVOR ..');
            let self = this;
            let total_cargos = 0;
            let total_abonos = 0;

            this.data_tableA = [];
            let data_cargos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_cargo: this.fecha_de,
                destinos: this.destinos_cargos
            };
            let data_abonos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_abono: this.fecha_de,
                destinos: this.destinos_abonos
            };
            if (this.planta != '') {
                data_cargos = {
                    rfc: this.$local_storage.get("rfc"),
                    fecha_cargo: this.fecha_de,
                    destinos: this.destinos_cargos,
                    planta: this.planta
                }
                data_abonos = {
                    rfc: this.$local_storage.get("rfc"),
                    fecha_abono: this.fecha_de,
                    destinos: this.destinos_abonos,
                    planta: this.planta
                }

            }

            if (this.valoracion == 'EJERCICIO FISCAL') {
                axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_anio/", data_cargos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            let cargos = res.data;
                            cargos = res.data.sort(function (a, b) {
                                return parseInt(b.anio) - parseInt(a.anio);
                            });
                         
                            axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_anio/", data_abonos)
                                .then(res => {
                                    if (typeof res.data !== "undefined") {
                                        cargos.forEach(function (c) {
                                            self.data_tableA.push({
                                                "ejercicio": c.anio,
                                                "cargos": parseInt(c.valor),
                                                "abonos": "0",
                                                "porcentaje": "0",

                                            });
                                        });
                                        let abonos = res.data;
                                        abonos.forEach(function (a) {
                                            let encontrado = self.data_tableA.filter(item => {
                                                return item.ejercicio == a.anio
                                            });

                                            if (encontrado.length > 0) {
                                                encontrado[0].abonos = parseInt(a.valor);
                                                encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                            } else {
                                                self.data_tableA.push({
                                                    "ejercicio": a.anio,
                                                    "cargos": "0",
                                                    "abonos": parseInt(a.valor),
                                                    "porcentaje": "0",

                                                });
                                            }

                                        });
                                        self.llenarGrafica1();

                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.loading = false;
                                }).then(res => {
                                    this.dialog = false;
                                    this.loading = false;
                                    this.$refs.fracesLoader.hide();
                                });

                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    }).then(res => {
                        this.dialog = false;
                        this.$refs.fracesLoader.hide();
                    });

            } else {
                axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_mes/", data_cargos)
                    .then(res => {
                        if (typeof res.data !== "undefined") {
                            let cargos = res.data;

                            axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_mes/", data_abonos)
                                .then(res => {
                                    if (typeof res.data !== "undefined") {

                                        let abonos = res.data;
                                        let cuenta_bimestre = 1;
                                        cargos.forEach(function (c) {
                                            if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                                if (c.mes % 2 == 0) {
                                                    var exists_bimestre = self.data_tableA.filter(item => {
                                                        return item.ejercicio == c.anio + '-' + self.meses[c.mes - 1] + '-' + self.meses[c.mes]
                                                    });
                                                } else {
                                                    var exists_bimestre = self.data_tableA.filter(item => {
                                                        return item.ejercicio == c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1]
                                                    });
                                                }
                                                if(cuenta_bimestre < 7 || exists_bimestre.length > 0){ 
                                                    if (c.mes % 2 == 0) {
                                                        self.data_tableA.push({

                                                            "ejercicio": c.anio + '-' + self.meses[c.mes - 1] + '-' + self.meses[c.mes],
                                                            "cargos": parseInt(c.valor),
                                                            "abonos": "0",
                                                            "porcentaje": "0",

                                                        });

                                                        total_cargos += parseInt(c.valor);
                                                        cuenta_bimestre +=1;
                                                    } else {
                                                        let encontrado2 = self.data_tableA.filter(item => {
                                                            return item.ejercicio == c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1]
                                                        });

                                                        if (encontrado2.length > 0) {
                                                            encontrado2[0].cargos = parseInt(encontrado2[0].cargos) + parseInt(c.valor);
                                                            encontrado2[0].porcentaje = parseInt((parseFloat(encontrado2[0].abonos) / parseFloat(encontrado2[0].cargos)) * 100);
                                                            total_cargos += parseInt(c.valor);
                                                        } else {
                                                            self.data_tableA.push({

                                                                "ejercicio": c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1],
                                                                "cargos": parseInt(c.valor),
                                                                "abonos": "0",
                                                                "porcentaje": "0",

                                                            });
                                                            total_cargos += parseInt(c.valor);
                                                            cuenta_bimestre +=1;
                                                        }

                                                    }
                                                }
                                            } else {
                                                total_cargos += parseInt(c.valor);
                                                self.data_tableA.push({

                                                    "ejercicio": c.anio + '-' + self.meses[c.mes],
                                                    "cargos": parseInt(c.valor),
                                                    "abonos": "0",
                                                    "porcentaje": "0",

                                                });
                                            }

                                        });
                                        abonos.forEach(function (a) {

                                            if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                                if (a.mes % 2 == 0) {
                                                    let encontrado = self.data_tableA.filter(item => {
                                                        return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes - 1]
                                                    });

                                                    if (encontrado.length > 0) {
                                                        encontrado[0].abonos = parseInt(encontrado[0].abonos) + parseInt(a.valor);
                                                        encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                        total_abonos += parseInt(a.valor);
                                                    }
                                                } else {
                                                    let encontrado = self.data_tableA.filter(item => {
                                                        return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes + 1]
                                                    });

                                                    if (encontrado.length > 0) {
                                                        encontrado[0].abonos = parseInt(a.valor);
                                                        encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                        total_abonos += parseInt(a.valor);
                                                    }
                                                }
                                            } else {
                                                let encontrado = self.data_tableA.filter(item => {
                                                    return item.ejercicio == a.anio + '-' + self.meses[a.mes]
                                                });

                                                if (encontrado.length > 0) {
                                                    total_abonos += parseInt(a.valor);
                                                    encontrado[0].abonos = parseInt(a.valor);
                                                    encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                }
                                            }

                                        });
                                        self.llenarGrafica1();
                                        if (self.valoracion == "ULTIMOS 12 MESES") {
                                            self.data_tableA.push({

                                                "ejercicio": 'TOTAL',
                                                "cargos": total_cargos,
                                                "abonos": total_abonos,
                                                "porcentaje": parseInt((total_abonos / total_cargos) * 100),

                                            });
                                        }

                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    this.loading = false;
                                }).then(res => {
                                    this.dialog = false;
                                    this.loading = false;
                                    this.$refs.fracesLoader.hide();
                                    this.guardarConfig();
                                });

                        }
                    })
                    .catch(err => {
                        console.log(err);
                        this.loading = false;
                    });
            }

        },
        async llenarGrafica1() {
            let self = this;
            let data = [];
            self.data_grafica1.xAxis.categories = [];
           
            self.data_grafica1.xAxis.categories = [];
            self.data_tableA.forEach(function (x) {
                data.push({
                    y: parseInt(x.porcentaje),
                    name: x.ejercicio
                })
                self.data_grafica1.xAxis.categories.push(x.ejercicio);
            });

            self.data_grafica1.series[0] = {
                data: data,
                colorByPoint: true
            };

        },

        consultaDesgloses: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            let fd = "";
            let fa = "";
            let total_cargos_iva = 0;
            let total_cargos_ieps = 0;

            let self = this;
            self.data_grafica2.series = [];
            this.data_tableB = [];
            if (this.valoracion2 == 'EJERCICIO FISCAL') {
                fd = this.ejercicio + '-01-01';
                if (parseInt(self.ultimo_presentado[0].ejercicio) == parseInt(this.ejercicio)) {
                    fa = self.ultimo_presentado[0].fecha;
                } else {
                    fa = this.ejercicio + '-12-31';
                }

            } else {
                let self = this;
                var f_a = new Date(self.ultimo_presentado[0].fecha);

                let y = f_a.getFullYear();
                let m = f_a.getMonth() + 1;
                let d = f_a.getDate();
                if (m < 10)
                    m = '0' + m;
                if (d < 10)
                    d = '0' + d;

                fd = (y - 1) + "-" + m + "-" + d;
                fa = y + "-" + m + "-" + d;
            }

            self.fecha_de2 = fd;
            self.fecha_a2 = fa;

            let data_cargos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_de: fd,
                fecha_a: fa,
                destinos: this.destinos_cargos
            };
            let data_abonos = {
                rfc: this.$local_storage.get("rfc"),
                fecha_de: fd,
                fecha_a: fa,
                destinos: this.destinos_abonos
            };
            if (this.planta != '') {
                data_cargos = {
                    rfc: this.$local_storage.get("rfc"),
                    fecha_de: fd,
                    fecha_a: fa,
                    destinos: this.destinos_cargos,
                    planta: this.planta
                }
                data_abonos = {
                    rfc: this.$local_storage.get("rfc"),
                    fecha_de: fd,
                    fecha_a: fa,
                    destinos: this.destinos_abonos,
                    planta: this.planta
                }

            }
            axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_destino/", data_cargos)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        let cargos = res.data;
                        cargos = cargos.sort(function (a, b) {
                            return a.destino > b.destino ? 1 : -1;
                        });
                        self.data_tableB_cargos = cargos;

                        self.total_saldo = 0;
                        self.porcentaje_saldo = 0;
                        let total_cargos = 0;
                        cargos.forEach(x => {
                            total_cargos += parseInt(x.valor);
                            total_cargos_ieps += parseInt(x.ieps);
                            total_cargos_iva += parseInt(x.iva);
                            self.data_grafica2.series.push({
                                name: x.destino,
                                data: [parseInt(x.valor), '']
                            }, );
                        });
                        self.data_tableB_cargos = self.data_tableB_cargos.sort(function (a, b) {
                            return a.destino > b.destino ? 1 : -1;
                        });
                        self.data_tableB_cargos.push({
                            'destino': "TOTAL",
                            'valor': total_cargos,
                            "iva": total_cargos_iva,
                            "ieps": total_cargos_ieps,
                        });

                        axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_destino/", data_abonos)
                            .then(res => {
                                if (typeof res.data !== "undefined") {

                                    let abonos = res.data;
                                    abonos = abonos.sort(function (a, b) {
                                        return a.destino > b.destino ? 1 : -1;
                                    });
                                    self.data_tableB_abonos = abonos;

                                    let total = 0;
                                    abonos.forEach(x => {
                                        x.valor = parseInt(x.valor);
                                        total += parseInt(x.valor);
                                        self.data_grafica2.series.push({
                                            name: x.destino,
                                            data: ['', parseInt(x.valor)]
                                        }, );

                                    });
                                    self.data_tableB_abonos = self.data_tableB_abonos.sort(function (a, b) {
                                        return a.destino > b.destino ? 1 : -1;
                                    });
                                    self.data_tableB_abonos.push({
                                        'destino': "TOTAL",

                                        'valor': parseInt(total)
                                    });
                                    self.total_saldo = total_cargos - parseInt(total);
                                    self.porcentaje_saldo = parseInt((total / total_cargos) * 100);
                                }
                            })
                            .catch(err => {
                                console.log(err);
                                this.loading = false;
                            }).then(res => {
                                this.loading = false;
                                this.$root.$dialogLoader.hide();
                            });

                    }
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                }).then(res => {
                    this.$root.$dialogLoader.hide();
                    this.loading = false;
                });

        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
       

    },

    mounted: function () {
        if (this.$local_storage.get('verSA31')==0){
            this.crear();
        }
        this.dialog_info=  this.$local_storage.get('verSA31')==1;
    }
};
</script>
    
    
<style scoped>
.footer-hide>>>.VuePagination {
    display: none;
}

.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
    color: black;
    font-size: small;
    background-color: transparent;
    padding: 0px;
}

.v-tab {
    border-bottom: 2px solid #0E4D78;
    background-color: #F4F4F4 !important;
    font-size: small;
    margin-top: 5px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
    color: white;
    font-size: small;
    background-color: #0E4D78 !important;
    padding: 0px;
    font-weight: bold;

}

.v-tabs-slider-wrapper {
    left: 0 !important;
}

.table-bordered thead th,
.table-bordered thead td {
    font-size: x-small !important;
}

.box {
    width: 95%;
    height: 100%;
    margin-top: -30px;
}

.circle {
    border-radius: 50%;
    width: 34px;
    height: 34px;
    padding: 10px;
    background: #fff;
    border: 5px solid #DF7205;
    color: #000;
    text-align: center;
    font: 32px Arial, sans-serif;
}

img {
    width: 100%;
    /* takes the 100 % width of its container (.box div)*/
    height: 100%;
    /* takes the 100 % height of its container (.box div)*/
}
</style>
